import Debug from 'debug'

const debug = Debug('error')

export function enrichError(error: any, ...context: any[]) {
  let richMessage
  try {
    if (context && context.length > 0) {
      error.message =
        richMessage = `[${new Date().getTime()}]${context.map(value => `[${value}]`).join(' ')} ${error.message}`
    }
  } catch (e) {
    debug(richMessage, e)
  }
  return error
}
